export const WoveHowItWorks: React.FC = () => {
  return (
    <div>
      <ul>
        <li>When editing a contact or linking a meeting participant in Zocks, use the Wove section to enter the client&apos;s Wove identifier.</li>
        <li>
          Zocks validates the identifier with Wove and links the contact to the correct Wove investor account; clearing the identifier unlinks the account.
        </li>
        <li>Once linked, Wove portfolio data powers Meeting Prep, live meeting insights, emails, and forms inside Zocks.</li>
      </ul>
    </div>
  )
}
